var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuran(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.74 9.00001L58 10V5.00001C58.0004 4.84222 57.9635 4.68658 57.8922 4.5458C57.8209 4.40502 57.7174 4.2831 57.59 4.19001C57.4629 4.09867 57.3162 4.03842 57.1616 4.0141C57.0071 3.98979 56.8489 4.00208 56.7 4.05001L32 12L7.29998 4.05001C7.15102 4.00208 6.99289 3.98979 6.83832 4.0141C6.68374 4.03842 6.53703 4.09867 6.40998 4.19001C6.28258 4.2831 6.17902 4.40502 6.10776 4.5458C6.0365 4.68658 5.99957 4.84222 5.99998 5.00001V10L2.25998 9.00001C2.1109 8.96094 1.95481 8.95686 1.80389 8.98809C1.65297 9.01931 1.51132 9.08499 1.38998 9.18001C1.26488 9.27622 1.16432 9.40067 1.09654 9.54319C1.02876 9.68571 0.995666 9.84225 0.999976 10V40C0.992243 40.2258 1.06118 40.4475 1.19555 40.6291C1.32992 40.8107 1.52181 40.9414 1.73998 41L14 44.23V59C14.0003 59.1794 14.0488 59.3554 14.1405 59.5095C14.2322 59.6637 14.3637 59.7903 14.5211 59.8762C14.6786 59.9621 14.8563 60.0041 15.0355 59.9977C15.2148 59.9913 15.389 59.9369 15.54 59.84L32 49.19L48.46 59.84C48.6209 59.944 48.8084 59.9995 49 60C49.1675 60.0008 49.3326 59.9596 49.48 59.88C49.6378 59.7937 49.7694 59.6663 49.8609 59.5115C49.9524 59.3566 50.0005 59.1799 50 59V44.23L62.26 41C62.4781 40.9414 62.67 40.8107 62.8044 40.6291C62.9388 40.4475 63.0077 40.2258 63 40V10C62.9996 9.84729 62.9643 9.69668 62.8967 9.55974C62.8291 9.4228 62.731 9.30317 62.61 9.21001C62.4912 9.10983 62.3508 9.0387 62.1998 9.00225C62.0488 8.96579 61.8913 8.96503 61.74 9.00001ZM33 13.73L56 6.37001V26C48 25.38 37.12 33.47 33 36.81V13.73ZM33 39.46C35.19 37.6 47.79 27.24 56 28V34.23L33 41.63V39.46ZM7.99998 6.37001L31 13.73V36.85C26.88 33.51 16 25.42 7.99998 26V6.37001ZM7.99998 28C16.21 27.19 28.81 37.56 31 39.42V41.59L7.99998 34.27V28ZM16 57.12V44.77L29.56 48.38L16 57.12ZM48 57.12L34.44 48.38L48 44.77V57.12ZM61 39.23L32 47L2.99998 39.23V11.3L5.99998 12.1V35C5.98988 35.2206 6.05307 35.4383 6.1797 35.6192C6.30632 35.8001 6.48926 35.934 6.69998 36L31.7 44C31.8945 44.0663 32.1055 44.0663 32.3 44L57.3 36C57.5107 35.934 57.6936 35.8001 57.8203 35.6192C57.9469 35.4383 58.0101 35.2206 58 35V12.1L61 11.3V39.23Z",
    fill: "url(#paint0_linear_431_5225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_5225",
    x1: 0.999976,
    y1: 32,
    x2: 63,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F622E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#557C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5D8341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7E9F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#96B352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A4BF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A9C358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C7C95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F9D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9D56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9D775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FADB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FBE19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FCE9C0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuran);
export default __webpack_public_path__ + "static/media/quran.e9bae48b457d21f67499268678b09c72.svg";
export { ForwardRef as ReactComponent };